<template>
  <div class="balance-user" :style="{ '--height': height, }">
    <div class="index-view-top">
      <van-icon @click="toBack" name="arrow-left" size="28" color="#ffffff" />
      <div class="title">{{ type == '1' ? $t("phone.yjmx") : $t("head.balance") }}</div>
      <van-icon style="opacity: 0" name="ellipsis" size="28" color="#ffffff" />
    </div>
    <div class="time-screening">
      <div class="date" @click="dateShow = true">
        <span>{{ date_1 }}</span>
        <van-icon name="notes-o" size="20" />
      </div>
      <div class="to">{{ $t('balance.to') }}</div>
      <div class="date" @click="dateShow = true">
        <span>{{ date_2 }}</span>
        <van-icon name="notes-o" size="20" />
      </div>
      <div class="btn" @click="screening">
        {{ $t("transactiondetails.select") }}
      </div>
    </div>
    <div class="money">
      <p @click="changeMoneyType('USDT')" :class="moneyType == 'USDT' ? 'active' : ''">
        USDT
      </p>
      <p @click="changeMoneyType('TRX')" :class="moneyType == 'TRX' ? 'active' : ''">
        TRX
      </p>
    </div>
    <ul class="infinite-list" v-infinite-scroll="load" style="overflow: auto">
      <div v-if="number.length < 1" style="padding:  3rem 0;color: #ffffff;text-align: center;">
        {{ $t("transactiondetails.not") }}
      </div>
      <div v-else class="details-lists" v-for="(item, index) in number" :key="index">
        <div class="item-top">
          <p>{{ item.name }}</p>
          <p :class="item.flowOp == '1' ? 'colorgreen' : 'colorred'">{{ item.flowOp == '1' ? '+' : '-' }}{{
              item.flowPrice
          }}</p>
        </div>
        <div class="item-bottom">
          <p>{{ item.createTime }}</p>
          <p>{{ $t("balance.balance_of") }}：{{ item.afterPrice }}</p>
        </div>
      </div>
    </ul>
    <van-calendar v-model="dateShow" type="range" color="#161414" allow-same-day :min-date="minDate"
      @confirm="onConfirm" />
  </div>
</template>

<script>
import { cashFlow } from '@/utils/request'
export default {
  data() {
    return {
      moneyType: 'USDT',
      number: [],
      type: '', // 类型 0：钱包，1：佣金
      current: 1,
      height: '', //屏幕高度
      date_1: '',
      date_2: '',
      dateShow: false,
      minDate: new Date(2021, 0, 1)
    }
  },
  //获取屏幕高度
  created() {
    let h = document.documentElement.clientHeight || document.body.clientHeight;
    if (h > 0) {
      this.height = h + 'px' //页面高度
    } else {
      this.height = "100vh"
    }
  },
  mounted() {
    this.type = this.$route.query.type
    this.cashFlow(this.type)
  },
  methods: {
    onConfirm(date) {
      this.date_1 = date[0].getFullYear() + '-' + (date[0].getMonth() + 1) + '-' + date[0].getDate()
      this.date_2 = date[1].getFullYear() + '-' + (date[1].getMonth() + 1) + '-' + date[1].getDate()
      this.dateShow = false
    },
    screening() {
      this.current = 1
      this.cashFlow(this.type)
    },
    cashFlow(type) {
      var that = this
      that.current = 1
      let time = undefined
      if (this.date_1 && this.date_2) time = this.date_1 + ' ~ ' + this.date_2
      cashFlow({
        coin: that.moneyType,
        size: 10,
        current: that.current,
        type: type,
        time: time
      }).then(res => {
        if (res.code == '200') {
          that.number = res.data.records
        }
      })
    },
    load() {
      var that = this
      let time
      if (this.date_1 && this.date_2) time = this.date_1 + ' ~ ' + this.date_2
      cashFlow({
        coin: that.moneyType,
        size: 10,
        current: that.current + 1,
        type: that.type,
        time: time || ''
      }).then(res => {
        if (res.code == '200') {
          if (res.data.records.length > 0) {
            that.current += 1
            that.number = [...that.number, ...res.data.records]
          }
        }
      })
    },
    //选择币种类型
    changeMoneyType(item) {
      this.moneyType = item
      this.cashFlow(this.type)
    },
    toBack() {
      this.$router.push('/user')
    }
  }
}
</script>

<style lang="scss" scoped>
.balance-user {
  width: 100vw;
  height: var(--height);
  background: #0c0b0b;

  .colorred {
    color: #b51717 !important;
  }

  .colorgreen {
    color: green !important;
  }

  .time-screening {
    display: flex;
    height: 2.6875rem;
    background: #0c0b0b;
    border-radius: 0.25rem;
    padding: 0 0.9375rem;
    margin-bottom: 10px;

    .date {
      box-sizing: border-box;
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 7.5rem;
      height: 2.6875rem;
      padding: 0 0.625rem;
      background: #161414;
      border-radius: 0.25rem;
      font-size: 0.8125rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
    }

    .to {
      margin: 0 0.6875rem;
      font-size: 0.8125rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #ffffff;
      line-height: 2.6875rem;
    }

    .btn {
      width: 3.75rem;
      height: 2.6875rem;
      margin-left: 0.625rem;
      border-radius: 0.3125rem;
      border: 1px solid #f8c007;
      font-size: 0.9375rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #f8c007;
      line-height: 2.6875rem;
      text-align: center;
    }
  }

  .infinite-list {
    height: calc(var(--height) - 10.4375rem);
    background-color: #0c0b0b;
  }

  .details-lists {
    padding: 0.9375rem 0.9375rem;
    border-bottom: 0.0625rem solid #272727;

    .item-top {
      display: flex;
      justify-content: space-between;
      padding-bottom: 0.5rem;

      >p {
        font-size: 0.8125rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #ffffff;
      }
    }

    .item-bottom {
      display: flex;
      justify-content: space-between;

      >p {
        font-size: 0.8125rem;
        font-family: PingFang SC-Medium, PingFang SC;
        font-weight: 500;
        color: #999999;
      }
    }
  }

  .money {
    display: flex;
    justify-content: space-around;
    padding: 1rem 0;

    .active {
      color: #ffc400 !important;
      border-bottom: 0.0625rem solid #ffc400;
    }

    >p {
      font-size: 0.875rem;
      font-family: PingFang SC-Medium, PingFang SC;
      font-weight: 500;
      color: #999999;
      padding-bottom: 0.25rem;
    }
  }

  .index-view-top {
    height: 3.625rem;
    padding: 0 0.9375rem;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .title {
      font-size: 1.125rem;
      font-family: PingFang SC-Bold, PingFang SC;
      font-weight: bold;
      color: #ffffff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/user/balance.vue